<template>
  <div class="home-block-list">
    <action-bar>
      <search placeholder="请输入区块高度" @onSearch="onSearch"></search>
      <el-button type="primary" @click="handleToHomeChart()">首页大屏</el-button>
      <div class="fill"></div>
      <subscribe-block></subscribe-block>
    </action-bar>
    <common-bg-plate>
      <normal-table
        :table-data="tableData"
        :table-col="tableCol"
        :paging="paging"
        :show-edit="showEdit"
        :operator="operator"
        :operate-col="operatorCol"
        @pagination="getBlockListFn"
      ></normal-table>
    </common-bg-plate>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import subscribeBlock from '../components/subscribeBlock'
export default {
  name: 'List',
  components: {
    subscribeBlock
  },
  data() {
    return {
      showEdit: true,
      operator: [
        {
          text: '查看',
          showText: true,
          icon: 'icon-check',
          class: 'operate-check',
          click: (row, col, cellValue) => {
            return this.goDetail(row)
          }
        }
      ],
      operatorCol: {
        minWidth: 74
      },
      tableCol: [
        {
          label: '区块Hash',
          prop: 'blockHash',
          minWidth: 561
        },
        {
          label: '出块节点',
          prop: 'proposer_id',
          minWidth: 290
        },
        {
          label: '区块高度',
          prop: 'blockHeight',
          minWidth: 116
        },
        {
          label: '生成时间',
          prop: 'timestamp',
          minWidth: 158
        }
      ]
    }
  },
  computed: {
    ...mapState({
      tableData: state => state.home.block_list,
      paging: state => state.home.block_paging
    })
  },
  watch: {
    '$store.state.home.chainCid': {
      deep: true,
      handler() {
        this.getBlockListFn()
      }
    }
  },
  mounted() {
    if (this.$store.state.home.chainCid) {
      this.getBlockListFn()
    }
  },
  methods: {
    ...mapActions(['getBlockLists']),
    onSearch(val) {
      if (!Number(val)) {
        this.$message.error('查询条件错误')
        return
      }
      this.getBlockListFn({
        offset: 0,
        limit: 10,
        height: val
      })
    },
    getBlockListFn(params = {}) {
      params.offset = params.offset * this.paging.limit || 0
      params.limit = params.limit || 10
      params.chainId = this.$store.state.home.chainCid
      this.getBlockLists(params)
    },
    goDetail(row) {
      this.$router.push({
        name: 'blockDetail',
        query: { blockHeight: row.blockHeight }
      })
    },
    handleToHomeChart() {
      this.$router.push('../dataAnalysis')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'home-block-list',
  (
    --home-block-list-operate-check-color: #45c2ff
  ),
  (
    --home-block-list-operate-check-color: #45c2ff
  )
);
.home-block-list {
  @include adaptation(
    (
      --home-block-list-search-width: 253px,
      --home-block-list-offset: 48px
    )
  );
  --home-block-list-min-height: calc(
    var(--base-main-router-body-avaliable-height) - var(--home-block-list-offset)
  );
  .cbaas-search-wrap {
    width: var(--home-block-list-search-width);
  }

  .common-bg-plate {
    .normal-table-wrap {
      height: 100%;
      min-height: var(--home-block-list-min-height);

      /deep/ {
        .el-empty {
          height: 100%;
          min-height: var(--home-block-list-min-height);
        }

        .normal-table {
          height: 100%;
          min-height: var(--home-block-list-min-height);

          .operate-item.operate-check {
            color: var(--home-block-list-operate-check-color);
          }
        }
      }
    }
  }
}
</style>
